<template>
  <div>
    <div v-if="this.loading">
      Loading.....
    </div>
    <div v-else-if="this.errormessage">
      <oops :errormsg="errormessage" />
    </div>
    <div v-else-if="!this.loading && !this.errormessage">
      <div
        class="alert alert-info mb-3 d-none d-md-block"
        v-if="displayScouterKey"
      >
        You are viewing the Resource Questionnaire for
        <span class="h5">{{ scouter.FullName }}</span>.
        <p-button
          type="button"
          link
          size="sm"
          class="btn btn-default ml-4"
          @click="returnPage"
        >
          Return
        </p-button>
      </div>
      <div
        class="alert alert-info mb-3 d-block d-md-none"
        v-if="displayScouterKey"
      >
        <span style="font-size: 1.4em;">{{ scouter.FullName }}</span>
        <p-button
          type="button"
          link
          size="sm"
          class="btn btn-default ml-2"
          @click="returnPage"
        >
          Return
        </p-button>
      </div>
      <ValidationObserver ref="form">
        <form @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <card
                class="card-user pb-2"
              >
                <div
                  class="image"
                  style="
                    background-color: #343434;
                    border-radius: 12px 12px 0 0;
                    height: 91.8px;"
                />
                <div class="card-body">
                  <div class="author">
                    <a href="#">
                      <img
                        v-if="scouter.PictureUrl"
                        class="avatar border-gray"
                        :class="{ readonly: readonly }"
                        style="height: 124px; width: 124px"
                        :src="scouter.PictureUrl"
                        @click="captureTheUrl"
                      >
                      <img
                        v-else
                        class="avatar border-gray"
                        :class="{ readonly: readonly }"
                        @click="captureTheUrl"
                        fill="#123456"
                        style="height: 124px; width: 124px; color: #121232"
                        src="@/assets/bootstrap-icons/icons/person-circle.svg"
                        alt="click to add photo"
                        title="click to add photo"
                      >
                    </a>
                  </div>
                  <div class="row pt-3">
                    <div class="col-lg-6 col-md-6">
                      <ValidationProvider
                        name="firstName"
                        rules="required|max:100"
                        v-slot="{ passed, failed }"
                      >
                        <fg-input
                          name="firstName"
                          :error="failed ? 'Your first name is required.' : null"
                          :has-success="passed"
                          required
                          label="First Name"
                          :disabled="readonly"
                          max-length="100"
                          v-model="scouter.FirstName"
                        />
                      </ValidationProvider>
                    </div>
                    <div class="col-lg-6 col-md-6">
                      <ValidationProvider
                        name="lastName"
                        rules="required|max:100"
                        v-slot="{ passed, failed }"
                      >
                        <fg-input
                          name="lastName"
                          :error="failed ? 'Your last name is required.' : null"
                          :has-success="passed"
                          required
                          label="Last Name"
                          :disabled="readonly"
                          max-length="100"
                          v-model="scouter.LastName"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                  <fg-input
                    name="preferredName"
                    label="Preferred Name"
                    max-length="255"
                    :disabled="readonly"
                    v-model="scouter.PreferredName"
                  />
                  <div class="row">
                    <div class="col-lg-6 col-md-6">
                      <fg-input>
                        <label>Birth Date</label>
                        <el-date-picker
                          class="input-default"
                          name="birthDate"
                          v-model="scouter.BirthDate"
                          :disabled="readonly"
                          type="date"
                          format="MMM d, yyyy"
                          value-format="yyyy-MM-ddTHH:mm:ss"
                          placeholder=""
                        />
                      </fg-input>
                    </div>
                    <div class="col-lg-6 col-md-6">
                      <fg-input>
                        <label>Sex</label>
                        <el-select
                          class="select-default2"
                          size="large"
                          name="sex"
                          placeholder=""
                          :disabled="readonly"
                          v-model="scouter.Sex"
                        >
                          <el-option
                            value="Female"
                            key="F"
                          >
                            Female
                          </el-option>
                          <el-option
                            value="Male"
                            key="M"
                          >
                            Male
                          </el-option>
                        </el-select>
                      </fg-input>
                    </div>
                  </div>
                  <fg-input
                    name="occupation"
                    label="Occupation"
                    max-length="255"
                    :disabled="readonly"
                    v-model="scouter.Occupation"
                  />
                </div>
              </card>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <card>
                <div class="card-body">
                  <div class="card-header pt-0">
                    <h4 class="title mt-0">
                      Contact Info
                    </h4>
                  </div>
                  <div class="card-body">
                    <ValidationProvider
                      name="emailAddress"
                      rules="email"
                      v-slot="{ passed, failed }"
                    >
                      <fg-input
                        name="emailAddress"
                        label="Email Address"
                        :error="failed ? 'This must be a valid email.' : null"
                        :has-success="passed"
                        max-length="255"
                        type="email"
                        :disabled="readonly"
                        v-model="scouter.EmailAddress"
                      />
                    </ValidationProvider>
                    <fg-input
                      name="telephoneNumber"
                      label="Telephone Number"
                      max-length="20"
                      type="tel"
                      :disabled="readonly"
                      v-model="scouter.PhoneNumber"
                    />
                    <fg-input
                      name="streetAddress"
                      label="Street Address"
                      max-length="255"
                      :disabled="readonly"
                      v-model="scouter.StreetAddress"
                    />
                    <fg-input
                      name="city"
                      label="City"
                      max-length="255"
                      :disabled="readonly"
                      v-model="scouter.City"
                    />
                    <div class="row">
                      <div class="col-lg-7 col-md-7">
                        <fg-input>
                          <label>State</label>
                          <el-select
                            class="select-default2"
                            size="large"
                            name="state"
                            :disabled="readonly"
                            placeholder=""
                            v-model="scouter.State"
                          >
                            <el-option
                              v-for="option in states"
                              class="select-default2"
                              :value="option.key"
                              :label="option.name"
                              :key="option.key"
                            />
                          </el-select>
                        </fg-input>
                      </div>
                      <div class="col-lg-5 col-md-5">
                        <fg-input
                          name="zipCode"
                          label="Zip Code"
                          max-length="10"
                          :disabled="readonly"
                          type="tel"
                          v-model="scouter.ZipCode"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
          <card v-if="this.$root.courseScouterType === 'Staff'">
            <div class="card-header pt-0">
              <h4 class="title mt-0">
                Original Course Info & Bio
              </h4>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-3">
                <fg-input
                  name="courseType"
                  label="Course Type"
                  max-length="255"
                  :disabled="readonly"
                  v-model="scouter.PriorCourseType"
                />
              </div>
              <div class="col-lg-3 col-md-3">
                <fg-input
                  name="courseType"
                  label="Course Number"
                  max-length="255"
                  :disabled="readonly"
                  v-model="scouter.PriorCourseName"
                />
              </div>
              <div class="col-lg-3 col-md-3">
                <fg-input
                  name="courseWhere"
                  label="Where"
                  max-length="255"
                  :disabled="readonly"
                  v-model="scouter.PriorCourseWhere"
                />
              </div>
              <div class="col-lg-3 col-md-3">
                <fg-input>
                  <label>Patrol</label>
                  <el-select
                    class="select-default2"
                    size="large"
                    name="priorcritter"
                    placeholder=""
                    :disabled="readonly"
                    v-model="scouter.PriorCritter"
                  >
                    <el-option
                      v-for="option in critters"
                      class="select-default2"
                      :value="option.name"
                      :label="option.name"
                      :key="option.name"
                    />
                  </el-select>
                </fg-input>
              </div>
            </div>
            <fg-input>
              <label for="bio">Staff Bio</label>
              <textarea
                :disabled="readonly"
                class="form-control"
                placeholder="It was a dark and stormy night..."
                id="bio"
                v-model="scouter.StaffBio"
              />
            </fg-input>
            <button
              :disabled="readonly"
              type="submit"
              class="btn btn-primary"
            >
              Submit
            </button>
          </card>
          <card>
            <div class="card-header pt-0">
              <h4 class="title mt-0">
                Scouting Experience
              </h4>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-6">
                <fg-input
                  name="yearsAdult"
                  label="Years in Scouting (Adult)"
                  type="number"
                  :disabled="readonly"
                  v-model="scouter.YearsScoutingAdult"
                />
              </div>
              <div class="col-lg-3 col-md-6">
                <fg-input
                  name="yearsAdult"
                  label="Years in Scouting (Youth)"
                  type="number"
                  :disabled="readonly"
                  v-model="scouter.YearsScoutingYouth"
                />
              </div>
              <div class="col-lg-3 col-md-6">
                <fg-input
                  name="district"
                  label="Home District"
                  max-length="255"
                  :disabled="readonly"
                  v-model="scouter.District"
                />
              </div>
              <div class="col-lg-3 col-md-6">
                <fg-input>
                  <label>Home Council</label>
                  <el-select
                    class="select-default2"
                    size="large"
                    name="council"
                    placeholder=""
                    :disabled="readonly"
                    v-model="scouter.CouncilId"
                  >
                    <el-option
                      v-for="c in councils"
                      class="select-default2"
                      :value="c.Id"
                      :label="c.CouncilName"
                      :key="c.Id"
                    />
                  </el-select>
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-3">
                <fg-input>
                  <label>Primary Scouting Program</label>
                  <el-select
                    class="select-default2"
                    size="large"
                    name="program"
                    placeholder=""
                    :disabled="readonly"
                    v-model="scouter.PrimaryScoutingProgram"
                  >
                    <el-option
                      v-for="option in programs"
                      class="select-default2"
                      :value="option.id"
                      :label="option.name"
                      :key="option.id"
                    />
                  </el-select>
                </fg-input>
              </div>
              <div class="col-lg-3 col-md-3">
                <fg-input>
                  <label>Primary Scouting Position</label>
                  <el-select
                    class="select-default2"
                    size="large"
                    name="programposition"
                    placeholder=""
                    :disabled="readonly"
                    v-model="scouter.PrimaryScoutingPosition"
                  >
                    <el-option
                      v-for="pos in currentPositions"
                      class="select-default2"
                      :value="pos.Id"
                      :label="pos.PositionName"
                      :key="pos.Id"
                    />
                  </el-select>
                </fg-input>
              </div>
              <div class="col-lg-6 col-md-6">
                <fg-input>
                  <label for="otherPositions">Other Scouting Positions</label>
                  <textarea
                    :disabled="readonly"
                    class="form-control"
                    placeholder=""
                    id="otherPositions"
                    v-model="scouter.OtherPositionsHeld"
                  />
                </fg-input>
              </div>
            </div>
            <fg-input>
              <label for="scoutingAwards">Scouting Awards Received</label>
              <textarea
                :disabled="readonly"
                class="form-control"
                placeholder=""
                id="scoutingAwards"
                v-model="scouter.ScoutingAwards"
              />
            </fg-input>
            <button
              :disabled="readonly"
              type="submit"
              class="btn btn-primary"
            >
              Submit
            </button>
          </card>
          <card>
            <div class="card-header pt-0">
              <h4 class="title mt-0">
                Personal Profile
              </h4>
            </div>
            <fg-input>
              <label for="physical">Physical Condition</label>
              <textarea
                :disabled="readonly"
                class="form-control"
                placeholder=""
                id="condition"
                v-model="scouter.PhysicalCondition"
              />
            </fg-input>
            <fg-input>
              <label for="needs">Dietary, Physical, Special Needs</label>
              <textarea
                :disabled="readonly"
                class="form-control"
                placeholder=""
                id="needs"
                v-model="scouter.SpecialNeeds"
              />
            </fg-input>
            <div class="row">
              <div class="col-lg-4 col-md-5">
                <fg-input
                  name="position"
                  label="Religious Preference"
                  max-length="255"
                  :disabled="readonly"
                  v-model="scouter.ReligiousPreference"
                />
              </div>
              <div class="col-lg-8 col-md-7">
                <fg-input>
                  <label for="relNeeds">Religious Needs</label>
                  <textarea
                    :disabled="readonly"
                    class="form-control"
                    placeholder=""
                    id="relNeeds"
                    v-model="scouter.ReligiousNeeds"
                  />
                </fg-input>
              </div>
            </div>
            <button
              :disabled="readonly"
              type="submit"
              class="btn btn-primary"
            >
              Submit
            </button>
          </card>
          <card>
            <div class="card-header pt-0">
              <h4 class="title mt-0">
                Training & Outdoor Experience
              </h4>
            </div>
            <fg-input>
              <label for="training">Training</label>
              <textarea
                :disabled="readonly"
                class="form-control"
                placeholder=""
                id="training"
                v-model="scouter.Training"
              />
            </fg-input>
            <fg-input>
              <label for="camping">Camping Experience</label>
              <textarea
                :disabled="readonly"
                class="form-control"
                placeholder=""
                id="camping"
                v-model="scouter.CampingExperience"
              />
            </fg-input>
            <fg-input>
              <label for="firstaid">First Aid Training</label>
              <textarea
                :disabled="readonly"
                class="form-control"
                placeholder=""
                id="firstaid"
                v-model="scouter.FirstAid"
              />
            </fg-input>
            <button
              :disabled="readonly"
              type="submit"
              class="btn btn-primary"
            >
              Submit
            </button>
          </card>
          <card v-if="this.$root.courseScouterType === 'Participant'">
            <div class="card-header pt-0">
              <h4 class="title mt-0">
                Previous Course Attended
              </h4>
            </div>
            <div class="row">
              <div class="col-lg-3 col-md-3">
                <fg-input
                  name="courseType"
                  label="Course Type"
                  max-length="255"
                  :disabled="readonly"
                  v-model="scouter.PriorCourseType"
                />
              </div>
              <div class="col-lg-3 col-md-3">
                <fg-input
                  name="courseType"
                  label="Course Number"
                  max-length="255"
                  :disabled="readonly"
                  v-model="scouter.PriorCourseName"
                />
              </div>
              <div class="col-lg-3 col-md-3">
                <fg-input
                  name="courseWhere"
                  label="Where"
                  max-length="255"
                  :disabled="readonly"
                  v-model="scouter.PriorCourseWhere"
                />
              </div>
              <div class="col-lg-3 col-md-3">
                <fg-input>
                  <label>Patrol</label>
                  <el-select
                    class="select-default2"
                    size="large"
                    name="priorcritter"
                    placeholder=""
                    :disabled="readonly"
                    v-model="scouter.PriorCirtter"
                  >
                    <el-option
                      v-for="option in critters"
                      class="select-default2"
                      :value="option.name"
                      :label="option.name"
                      :key="option.name"
                    />
                  </el-select>
                </fg-input>
              </div>
            </div>
          </card>
          <card>
            <div class="card-header pt-0">
              <h4 class="title mt-0">
                Emergency Contact & Recruitment
              </h4>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-5">
                <fg-input
                  name="emergencyContact"
                  label="Emergency Contact"
                  max-length="255"
                  :disabled="readonly"
                  v-model="scouter.EmergencyContact"
                />
              </div>
              <div class="col-lg-6 col-md-7">
                <fg-input
                  name="emergencyPhone"
                  label="Emergency Phone"
                  type="tel"
                  :disabled="readonly"
                  v-model="scouter.EmergencyPhone"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-5">
                <fg-input
                  name="recruitedBy"
                  label="Recruited By"
                  max-length="255"
                  :disabled="readonly"
                  v-model="scouter.RecruitedBy"
                />
              </div>
              <div class="col-lg-8 col-md-7">
                <fg-input>
                  <label for="why">Why did you sign up for the course?</label>
                  <textarea
                    :disabled="readonly"
                    class="form-control"
                    placeholder=""
                    id="why"
                    v-model="scouter.WhySignedUp"
                  />
                </fg-input>
              </div>
            </div>
            <fg-input>
              <label for="invites">Others to Invite to Attend</label>
              <textarea
                :disabled="readonly"
                class="form-control"
                placeholder=""
                id="invites"
                v-model="scouter.ParticipantRecruits"
              />
            </fg-input>
            <button
              :disabled="readonly"
              type="submit"
              class="btn btn-primary"
            >
              Submit
            </button>
          </card>
        </form>
      </ValidationObserver>
    </div>
    <capture-file
      :is-photo="isPhoto"
      ref="capturefile"
      @url-captured="onCapturedUrl"
    />
  </div>
</template>

<script>
import scouterApi from '@/services/api/scouter'
import courseApi from '@/services/api/course.js'
import statesList from '@/services/static/states'
import captureFile from '@/components/storage/capture-file.vue'
import oops from '@/components/_main/oops.vue'
import crittersList from '@/services/static/critters'
import programList from '@/services/static/programs'

import { extend } from 'vee-validate'
import { required, max, min, email } from 'vee-validate/dist/rules'

extend('required', required)
extend('max', max)
extend('min', min)
extend('email', email)

export default {
  name: 'ResourceQuestionnaire',
  components: {
    oops,
    captureFile
  },
  data: function () {
    return {
      callingPage: null,
      displayScouterKey: null,
      scouter: {},
      states: null,
      critters: null,
      programs: null,
      loading: true,
      errormessage: null,
      councils: [],
      programPositions: {},
      isPhoto: true
    }
  },
  watch: {
    'scouter.PrimaryScoutingProgram': function (newValue, oldValue) {
      if (!(oldValue === undefined || oldValue === newValue)) {
        this.scouter.PrimaryScoutingPosition = null
      }
      this.$forceUpdate()
    }
  },
  computed: {
    readonly: function () {
      return !(
        this.$root.isAdmin ||
        this.displayScouterKey === null ||
        this.displayScouterKey === undefined
      )
    },
    currentPositions: function () {
      if (this.scouter.PrimaryScoutingProgram) {
        return this.programPositions[this.scouter.PrimaryScoutingProgram]
      } else {
        return []
      }
    }
  },
  created () {
    this.states = statesList.GetStates()
    this.critters = crittersList.getCrittersFullList()
    this.programs = programList.getPrograms()
    this.councils = this.getCouncils()
    this.programPositions = this.getProgramPositions()
  },
  mounted () {
    this.readQueryString()
    const key = this.displayScouterKey ?? this.$root.scouterKey
    scouterApi
      .get(key)
      .then(x => {
        this.scouter = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    readQueryString: function () {
      if (this.$route.query.s && this.$route.query.r) {
        this.displayScouterKey = this.$route.query.s
        if (this.$route.query.r === 'list') {
          this.callingPage = '/staff/participants'
        } else if (this.$route.query.r === 'bio') {
          this.callingPage = '/staff/participant-bios'
        } else if (this.$route.query.r === 'staff') {
          this.callingPage = '/staff/list'
        } else if (this.$route.query.r === 'staff-edit') {
          this.callingPage = '/staff/list/edit'
        } else if (this.$route.query.r === 'participant-edit') {
          this.callingPage = '/staff/participants/edit'
        } else if (this.$route.query.r === 'patrol-list') {
          this.callingPage = '/staff/patrols'
        }
      }
    },
    getCouncils: function () {
      courseApi
        .getCouncilLookups()
        .then(x => {
          this.councils = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    getProgramPositions: function () {
      scouterApi
        .getProgramPositions()
        .then(x => {
          this.programPositions = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    captureTheUrl: function (event) {
      if (!this.readonly) {
        this.$refs.capturefile.showDialog()
      }
    },
    onCapturedUrl: function (newUrl) {
      this.scouter.PictureUrl = newUrl
      this.save()
    },
    updateField: function (fieldName) {
      const fieldValue = this.$refs[fieldName].value
      const key = this.displayScouterKey ?? this.$root.scouterKey

      scouterApi.update(key, fieldName, fieldValue).then(x => {
        this.scouter = x
      })
    },
    save: function () {
      return this.$refs.form.validate().then(res => {
        this.submitForm()
        return res
      })
    },
    submitForm: function () {
      scouterApi.update(this.scouter).then(x => {
        this.$notify({
          message: 'Update complete.',
          icon: 'nc-icon nc-satisfied',
          type: 'success',
          horizontalAlign: 'center',
          timeout: 2000
        })
      })
    },
    returnPage: function () {
      this.$router.push(this.callingPage)
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  max-width: 300px;
  max-height: 400px;
  cursor: pointer;
}
.readonly {
  cursor: not-allowed !important;
}
</style>
